<!-- <header class="w-full sticky top-0 z-20 text-gray-700 bg-gray-100 border-t border-gray-100 shadow-sm body-font">
    <div class="container flex flex-col items-start justify-between p-4 mx-auto md:flex-row">
        <a class="flex items-center mb-4 font-medium text-gray-900 title-font md:mb-0">
            <img src="/assets/images/surplustek-logo.png" class="w-36"/>
        </a>

        <div class="items-center h-full">

            <button (click) = "logout()"
                class="px-4 py-2 text-xs font-bold text-white uppercase transition-all duration-150 bg-orange-500 rounded shadow outline-none active:bg-teal-600 hover:shadow-md focus:outline-none ease">
                Logout
            </button>
        </div>
    </div>
</header> -->

<header class="w-full top-0 sticky bg-zinc-50 shadow-lg z-30 header py-3 px-4 flex items-center justify-between">
    <!-- Logo or Brand Name -->
    <div class="text-lg font-semibold text-gray-800">

    </div>

    <!-- Profile Section -->
    <div class="flex items-center space-x-2 border border-gray-400 px-3 py-1 rounded-lg">
        <div>
            <img  [src]="image" width="30px" height="30px" class="text-gray-400" alt="Image Not Found" (load)="onImageLoad()" (error)="onImageError()" [hidden]="isImageError">
        </div>
        <div *ngIf="isImageError">
            <svg xmlns="http://www.w3.org/2000/svg" width="2rem" height="2rem" class="text-gray-400"
                viewBox="0 0 24 24">
                <path fill="currentColor" fill-rule="evenodd"
                    d="M12 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8m-2 9a4 4 0 0 0-4 4v1a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-1a4 4 0 0 0-4-4z"
                    clip-rule="evenodd" />
            </svg>
        </div>
        <span class="text-gray-600 font-semibold text-sm">{{ name }}</span>
    </div>
</header>